import { render, staticRenderFns } from "./StockPhysicalAddress.vue?vue&type=template&id=46879b66&scoped=true&"
import script from "./StockPhysicalAddress.vue?vue&type=script&lang=js&"
export * from "./StockPhysicalAddress.vue?vue&type=script&lang=js&"
import style0 from "./StockPhysicalAddress.vue?vue&type=style&index=0&id=46879b66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46879b66",
  null
  
)

export default component.exports